import { request } from '@/request'
import { BarChart } from '@/components/common/'
import SideBar from '@/components/common/side-modal'

export default {
  name: 'dados_escola',
  components: {
    BarChart,
    SideBar
  },
  data () {
    return {
      model: { },
      alunos: { 
        totalAlunos: 0,
        vagasAlunos: [],
        por_curso: {labels: [], datasets: [{label: '', data: []}]},
        por_turma: {labels: [], datasets: [{label: '', data: []}]},
        por_periodo: {labels: [], datasets: [{label: '', data: []}]},
      },
      navs: [
        {
          titulo: 'Funcionários',
          subtitulo: '',
          subtDetalhe: '',
          largura: 900,
          identidade: 'funcionarios',
          abreProximo: true,
          aberto: false
        }
      ],
      navs2: [
        {
          titulo: 'Localização',
          subtitulo: '',
          subtDetalhe: '',
          largura: 900,
          identidade: 'sigsantos',
          abreProximo: true,
          aberto: false
        }
      ],
      funcionarios: {
        totalFuncionarios: 0,
        por_cargo: [],
        selecionado: ''
      },
      ideb: {
        '272': '35069607',
        '221': '35075668',
        '227': '35203828',
        '267': '35056145',
        '264': '35056236',
        '268': '35203804',
        '266': '35056108',
        '832': '35390872',
        '233': '35056170',
        '262': '35194864',
        '218': '35203836',
        '228': '35078924',
        '229': '35076843',
        '237': '35207093',
        '1495': '35429983',
        '269': '35056121',
        '224': '35089977'
      }
    }
  },
  methods: {
    dadosGrafico (array, label, subitem, sublabel) {
      var base = { labels: [], datasets: [{ label: label, data: [] }] }
      var sub = { label: sublabel, data: [] }
      var keys = Object.keys(array)
      base.labels = keys

      for (let index = 0; index < keys.length; index++) {
        base.datasets[0].data.push(array[keys[index]].length)

        if (subitem !== undefined) {
          sub.data.push(array[keys[index]][0][subitem])
        }
      }

      if (subitem !== undefined) {
        base.datasets.push(sub)
      }
      return base
    },
    abrir (identidade, id) {
      this.$emit('abreModal', identidade)
      this.funcionarios.selecionado = this.funcionarios.por_cargo[id][0].cargo
    },
    abrirMapa (identidade) {
      this.$emit('abreModal', identidade)
    }
  },
  computed: {
    totalVagas() {
      let total = 0

      for (const key in this.alunos.vagasAlunos) {
        if (this.alunos.vagasAlunos.hasOwnProperty(key)) {
          total += parseInt(this.alunos.vagasAlunos[key][0].vagas)
        }
      }

      return total
    },
    capacidadeMaxima() {
      let total = 0

      for (const key in this.alunos.vagasAlunos) {
        if (this.alunos.vagasAlunos.hasOwnProperty(key)) {
          total += parseInt(this.alunos.vagasAlunos[key][0].quantidademaxima)
        }
      }

      return total
    },
    vagasExcedentes() {
      return this.totalVagas - this.alunos.totalAlunos
    },
    vagasPorCurso() {
      let keys = Object.keys(this.alunos.vagasAlunos)
      let capacidadeCurso = { porcurso: {}, porperiodo: {}}
      let sub = {
        porcurso: { label: 'Capacidade', data: [] },
        porperiodo: { label: 'Capacidade', data: [] }
      }
      var aux = 0

      keys.forEach(key => {
        if(capacidadeCurso.porcurso[this.alunos.vagasAlunos[key][0].curso] === undefined) {
          capacidadeCurso.porcurso[this.alunos.vagasAlunos[key][0].curso] = 0
        }

        if(capacidadeCurso.porperiodo[this.alunos.vagasAlunos[key][0].periodo] === undefined) {
          capacidadeCurso.porperiodo[this.alunos.vagasAlunos[key][0].periodo] = 0
        }

        aux = parseInt(this.alunos.vagasAlunos[key][0].vagas)
        capacidadeCurso.porcurso[this.alunos.vagasAlunos[key][0].curso] += aux
        capacidadeCurso.porperiodo[this.alunos.vagasAlunos[key][0].periodo] += aux
      })

      sub.porcurso.data = Object.values(capacidadeCurso.porcurso)
      sub.porperiodo.data = Object.values(capacidadeCurso.porperiodo)

      return sub
    }
  },
  beforeMount () {
    window.scrollTo(0, 0)
  },
  mounted () {
    request
    .get('educacao/listarEscolas?codigo=' + this.$route.query.escola)
    .then(response => {
      const { data } = response
      this.model = data.data
    })
    .catch(e => {
      console.log(e)
    })

    request
    .get('educacao/alunos/' + this.$route.query.escola)
    .then(response => {
      const { data } = response
      this.alunos.totalAlunos = data.data.totalAlunos
      this.alunos.vagasAlunos = data.data.porTurma

      this.alunos.por_curso = this.dadosGrafico(data.data.porCurso, 'Alunos')
      this.alunos.por_curso.datasets.push(this.vagasPorCurso.porcurso)

      this.alunos.por_periodo = this.dadosGrafico(data.data.porPeriodo, 'Alunos')
      this.alunos.por_periodo.datasets.push(this.vagasPorCurso.porperiodo)

      this.alunos.por_turma = this.dadosGrafico(data.data.porTurma, 'Alunos', 'vagas', 'Capacidade')
    })
    .catch(e => {
      console.log(e)
    })

    request
    .get('educacao/funcionarios/' + this.$route.query.escola)
    .then(response => {
      const { data } = response
      this.funcionarios.totalFuncionarios = data.data.totalFuncionarios
      this.funcionarios.por_cargo = data.data.porCargo 
    })
    .catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/views/public/educacao/detalhes/detalhes.js